import classNames from 'classnames';
import Moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DisplayErrorMessage from '../../../common/components/misc/DisplayErrorMessage';
import DisplayLoading from '../../../common/components/misc/DisplayLoading';
import * as Actions from '../../../common/services/offer/Actions';
import * as OfferService from '../../../common/services/offer/Service';
import { OfferShortDTO } from '../../../common/types/dto/OfferShortDTO';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';

interface ReduxStateProps {
    isCommunicating: boolean;
    offersListError: boolean;
    offersList: OfferShortDTO[];
}

interface ReduxDispatchProps {
    offerActions: typeof Actions;
    offerServiceActions: OfferService.ServiceActions;
}

type VehicleVisitsProperties =
    ReduxStateProps
    & ReduxDispatchProps;

const Offers: React.FC<VehicleVisitsProperties> = (Props) => {
    const { t } = useTranslation();

    // useEffect(() => {
    //    iframeScrollToTop();
    // }, []);

    useEffect(() => {
        if (Props.offersList.length === 0) {
            Props.offerServiceActions.allOffers();
        }
    }, [Props.offersList.length]);

    const buildOffersList = () => {
        if (Props.offersList.length > 0) {
            let table: JSX.Element[] = [];
            const expiredTable: JSX.Element[] = [];
            let content = null;

            Props.offersList.forEach((data: OfferShortDTO, key: number) => {
                const isExpired = (data.endDate && Moment(data.endDate) < Moment(new Date()));
                content = (
                    <div key={key} className={classNames(['cell', 'medium-4', 'pacotesOferta'])}>
                        <div className={'card'}>
                            <img src={'data:image;base64, ' + data.imageCard} />
                            <div className={classNames(['card-section', 'mensagem'])}>
                                <p>{data.title}</p>
                            </div>
                            <div className={classNames(['card-section', 'info'])}>
                                <p>{data.featured}</p>
                            </div>
                            <div className={'card-image'}>
                                {!isExpired && <a className={classNames(['button', 'campanha'])} href={`${config.BaseURL}/offers/${data.code}`} title="Informação detalhada">Informação detalhada</a>}
                                {isExpired && <div className={classNames(['button', 'campanha-expirada'])} style={{ cursor: 'unset' }} title="Oferta Expirada">Oferta Expirada</div>}
                            </div>
                        </div>
                    </div>
                );
                isExpired ? expiredTable.push(content) : table.push(content);
            });
            table = table.concat(expiredTable);
            return (
                <React.Fragment>
                    <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                        <div className={classNames(['grid-x', 'grid-margin-x'])} data-equalizer="bloco-pacotes" data-resize="bloco-pacotes" data-mutate="bloco-pacotes" data-events="mutate">
                            {table}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (<h3>{t('offers:no-offers')}</h3>);
        }
    };

    return (
        <React.Fragment>
            {!Props.isCommunicating && !Props.offersListError && buildOffersList()}
            <DisplayErrorMessage validation={Props.offersListError} />
            <DisplayLoading validation={Props.isCommunicating && !Props.offersListError} />
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.offerState.allOffers.isCommunicating,
    offersList: store.offerState.allOffers.data,
    offersListError: store.offerState.allOffers.error,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    offerActions: bindActionCreators(Actions, dispatch),
    offerServiceActions: OfferService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
